import { Link } from 'react-router-dom';
import { Home, Search } from 'lucide-react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

export default function NotFound() {
  const [q, setQ] = useState('');
  const navigate = useNavigate();
  return (
    <div className="grid min-h-[calc(100vh-4rem)] place-items-center px-4">
      <div className="max-w-md text-center">
        <p className="font-display text-7xl font-bold text-blue-600">404</p>
        <h1 className="mt-2 font-display text-2xl font-semibold text-slate-900">Page not found</h1>
        <p className="mt-1 text-slate-600">The page you&rsquo;re looking for doesn&rsquo;t exist or has moved. Try searching for a home instead.</p>
        <form onSubmit={(e) => { e.preventDefault(); navigate(`/listings?q=${encodeURIComponent(q)}`); }} className="mt-6 flex gap-2">
          <div className="relative flex-1"><Search size={16} className="absolute left-3 top-3 text-slate-400" /><Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search homes" className="rounded-xl pl-9" data-testid="notfound-search" /></div>
          <Button type="submit" className="rounded-xl">Search</Button>
        </form>
        <Button asChild variant="outline" className="mt-4 rounded-xl"><Link to="/"><Home size={16} className="mr-2" />Back home</Link></Button>
      </div>
    </div>
  );
}
